import * as CONSTANTS from '../../shared/constants';
import { renderWalls } from './WallRenderer';
import { renderExplosions } from './ExplosionRenderer';
import { renderUpgrades } from './UpgradeRenderer';
import { renderBombs } from './BombRenderer';
import { renderPlayers } from './PlayerRenderer';
import { renderGameOverScreen } from '../GameOverScreen';

const { CANVAS_WIDTH, CANVAS_HEIGHT } = CONSTANTS;

export const createGameRenderer = (drawStateRef) => {
  return () => {
    // Get current state from ref
    const {
      canvasRef,
      players,
      walls,
      bombs,
      explosions,
      upgrades,
      gameState,
      winner,
      gameOverCountdown,
      bombImage,
      bombSVGText,
      destructibleWallImage,
      indestructibleWallImage,
      floorImage,
      fireCenterImage,
      fireLineImage,
      fireEndImage,
      myPlayerId,
      characterSprites,
      characterSpriteSVGs,
      createColoredSprite,
      coloredSpritesCache,
      coloredBombCache,
      createColoredBomb,
      bombStateBuffers,
      interpolatePosition,
      playerStateBuffers,
      playerAnimationState,
      drawRef
    } = drawStateRef.current;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

    // Background/Floor
    if (floorImage) {
      // Render floor tiles
      const { GRID_SIZE } = CONSTANTS;
      const gridWidth = Math.ceil(CANVAS_WIDTH / GRID_SIZE);
      const gridHeight = Math.ceil(CANVAS_HEIGHT / GRID_SIZE);
      
      for (let x = 0; x < gridWidth; x++) {
        for (let y = 0; y < gridHeight; y++) {
          ctx.drawImage(floorImage, x * GRID_SIZE, y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        }
      }
    } else {
      // Fallback to solid color
      ctx.fillStyle = '#0f5132';
      ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
    }

    // Render game elements in order
    renderWalls(ctx, walls, destructibleWallImage, indestructibleWallImage);
    
    renderExplosions(ctx, explosions, fireCenterImage, fireLineImage, fireEndImage);
    
    renderUpgrades(ctx, upgrades);
    
    renderBombs(
      ctx,
      bombs,
      bombImage,
      bombSVGText,
      coloredBombCache,
      createColoredBomb,
      bombStateBuffers,
      interpolatePosition
    );
    
    renderPlayers(
      ctx,
      players,
      myPlayerId,
      playerStateBuffers,
      interpolatePosition,
      playerAnimationState,
      characterSprites,
      characterSpriteSVGs,
      coloredSpritesCache,
      createColoredSprite,
      drawRef
    );

    // Render game over screen if in gameOver state
    if (gameState === 'gameOver') {
      renderGameOverScreen(
        ctx,
        winner,
        gameOverCountdown,
        players,
        characterSprites,
        characterSpriteSVGs,
        coloredSpritesCache,
        createColoredSprite
      );
    }
  };
};